// @flow
import apiRequest from '../../stores/ApiService';
import apiConfig from '../../config';

const getAccessories = (baseApiUrl: string, fromItem: number, category: string = '') => {
  const baseUrl = `${baseApiUrl}/${apiConfig.urls.accessoriesConfiguration}?from=${fromItem}`;
  const url = category ? `${baseUrl}&category=${category}` : baseUrl;

  return apiRequest({
    method: 'GET',
    url,
  }).then((res) => res.json());
};

const getAccessory = (baseApiUrl: string, productType: string) =>
  apiRequest({
    method: 'GET',
    url: `${baseApiUrl}/${apiConfig.urls.accessoriesConfiguration}?productType=${productType}`,
  }).then((res) => res.json());

const getAccessoryPrice = (baseApiUrl: string, productName: string, quantity: number) =>
  apiRequest({
    method: 'GET',
    url: `${baseApiUrl}/${apiConfig.urls.accessoryPriceConfiguration}?productName=${productName}&quantity=${quantity}`,
  }).then((res) => res.json());

const addToCart = (baseApiUrl: string, product: string, quantity: number, storeCode: string) =>
  apiRequest({
    method: 'POST',
    url: `${baseApiUrl}/cartproduct?storeCode=${storeCode}`,
    body: JSON.stringify({
      add: [
        {
          id: product,
          quantity,
          type: 'accessory',
        },
      ],
    }),
  }).then((res) => res.json());

export default {
  getAccessories,
  getAccessory,
  getAccessoryPrice,
  addToCart,
};
